import { registerRavenHost, type RavenHost } from './host';
import { cdnProviderConsole, servicesRoutes } from './route';
import { serviceScopes } from './service';

/**
 * The module for the app to mount: its services-hub routes, its CDN-provider console and its catalog
 * scope (plain data; the console stays a lazy chunk behind `route.ts`). Taking the host is the only
 * way to get them, so the app cannot mount the module and forget what it reads at render time.
 */
export function createRavenModule(host: RavenHost) {
  registerRavenHost(host);
  return { servicesRoutes, cdnProviderConsole, serviceScopes };
}

export type { RavenHost } from './host';
